module.exports = __webpack_public_path__ + "img/jtr.24e306fb.svg";